<template>
  <div class="staff-page">
    <div class="page-header">
      <div class="search-box">
        <el-input class="search-input" :placeholder="'姓名 / 账号'" v-model="searchText" @input="startSearch" />
      </div>
      <div class="add-box" v-if="!User.is_palmyou">
        <div class="add-btn s-btn btn-blue is-plain" @click="addStaff">+ 新增</div>
      </div>
    </div>

    <table class="table-box" rules="groups" frame="box">
      <thead>
        <tr>
          <th>ID</th>
          <th width="136">姓名</th>
          <th class="text-center">账号</th>
          <th class="text-center">累计单量</th>
          <th class="text-center">创建时间</th>
          <th class="text-center">状态</th>
          <th class="text-center" width="210">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="v in dataModels" :key="v.peer_account_id">
          <td>{{v.peer_account_id}}</td>
          <td style="padding-right: 0;">
            <div class="name">
              <span>{{v.name}}</span>
              <span class="role-lable is-admin" v-if="v.role_id === 0">管理员</span>
              <span class="role-lable is-finance" v-else-if="v.role_id === 2">财务</span>
              <span class="role-lable is-operator" v-else-if="v.role_id === 1">操作员</span>
            </div>
          </td>
          <td class="text-center">{{v.mobile_phone}}</td>
          <td class="text-center">{{v.visa_count}}</td>
          <td class="text-center">{{v.create_time}}</td>
          <td class="text-center">
            <span  v-if="v.status===0">在职</span>
            <span class="color-red" v-if="v.status===1">离职</span>
          </td>
          <td class="text-center" v-if="v.is_admin"></td>
          <td class="text-center" v-if="!v.is_admin" >
            <template v-if="!User.is_palmyou && !v.status">
              <div class="btn" @click="onTransferAdmin($event, v)">移交管理员</div>
              <div class="btn" @click="editStaff($event, v)">编辑</div>
              <div class="btn" @click="block($event, v, 1)">注销</div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>


    <div class="nodata-box" v-if="!dataModels.length">
      <img class="nodata-img" src="../../../assets/imgs/new-user/nodata-member.png" alt="">
      <div class="nodata-text">未查询到成员记录</div>
    </div>

    <add-or-edit-staff-dialog
      :show.sync="staffDialog.visible"
      :type="staffDialog.type"
      :staff-info="staffDialog.staffInfo"
      @success="addOrEditSuccess"
    ></add-or-edit-staff-dialog>

    <common-count-down-dialog
      title="移交成功"
      :visible.sync="countDownDialog.visible"
      :seconds="3"
      :show-footer="false"
      @close="gotoBalance">
    </common-count-down-dialog>

  </div>
</template>

<script>
import _ from 'lodash';
import sensorsdata from 'sa-sdk-javascript';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import User from '../../../libs/user';

import AddOrEditStaffDialog from './components/add-or-edit-staff-dialog';
import commonCountDownDialog from '../../../components/common/modals/common-count-down-dialog/common-count-down-dialog.vue';

export default {
  components: {
    AddOrEditStaffDialog,
    commonCountDownDialog,
  },
  data() {
    return {
      dataModels: [],
      queryParams: { currentPage: 1 },
      User,
      searchText: '',
      staffDialog: {
        visible: false,
        type: 'add',
        staffInfo: null,
      },
      countDownDialog: {
        visible: false,
      },
    };
  },
  methods: {
    startSearch: _.debounce(function () {
      this.getData();
    }, 200),
    getData() {
      Http.post('/peer_account_query', {
        peer_account_id: User.peer_account_id,
      }).then((data) => {
        if (data.is_admin !== 1) {
          this.$router.replace('/');
        } else {
          Http.post('/peer_account_total_query', {
            condition: this.searchText || undefined,
          }).then((data) => {
            this.dataModels = data.result;
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      }).catch((e) => {
        if (e) console.log(e);
      });

    },
    addStaff(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.staffDialog.staffInfo = null;
      this.staffDialog.type = 'add';
      this.staffDialog.visible = true;
    },
    editStaff(e, item) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.staffDialog.staffInfo = item;
      this.staffDialog.type = 'edit';
      this.staffDialog.visible = true;
    },
    addOrEditSuccess() {
      this.getData();
    },
    async block(e, obj, status) {
      sensorsdata.quick('trackHeatMap', e.target);
      // const msg = status ? '注销' : '启用';
      const msgTitle = status ? '确定要注销该账号吗？' : '启用账号';
      const msgContent = status ? '账号注销操作不可逆，请确保员工离职时再注销账号' : '是否确定要启用该账号';

      // utils.msgbox.confirm(`是否确定要${msg}该账号`, `${msg}账号`, {

      await utils.msgbox.confirm(msgContent, msgTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      Http.post('/peer_account_status_switch', {
        peer_account_id: obj.peer_account_id,
        status,
      }).then(() => {
        utils.msg.success('操作成功');
        obj.status = status;
      }).catch((e) => {
        status && utils.msg.error('注销失败，请稍后重试');
      });

    },
    // 设为管理员
    onTransferAdmin(e, record) {
      const h = this.$createElement;
      const message = h('div', null, [
        h('p', null, `确定要移交管理员给${record.name} ${record.mobile_phone}吗？`),
        h('p', null, '移交后您会失去所有管理员权限，账号成为普通子账号'),
      ]);

      utils.msgbox.confirm(message, '确定要移交管理员吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        Http.post('/peer_admin_transfer', {
          peer_account_id: record.peer_account_id,
        }).then(() => { 
          this.countDownDialog.visible = true;
          // 更改为注销状态，清除定时器请求：因为后端进行数据清除，定时器请求请求到401就返回登录页了
          User.isSignOut = true;
        }).catch(() => {
          utils.msg.error('移交失败，请稍后重试');
        });
      }).catch(() => {});
    },
    gotoBalance() {
      // 重新开启
      User.isSignOut = false;
      this.$router.replace({ name: 'balance' });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.staff-page{
  padding: 24px;
  .page-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .search-box{
      position: relative;
      width: 340px;
      .search-input{
        /deep/ .el-input__inner{
          height: 40px;
          border: 1px solid #DEE2E6;
          border-radius: 2px;
        }
      }
      .search-btn{
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .add-box{
      .add-btn{
      }
    }
  }


  .table-box{
    margin-top: 24px;
    width:100%;
		font-size: 14px;
    border: none;
    color: #2F333D;
    thead{
      border:1px solid #E9EEF2;
      th{
        background-color: #FAFBFC;
        padding: 0 16px;
        text-align: left;
        font-weight: 600;
        height: 60px;
      }
    }
    tbody{
      tr{
        border-bottom: 1px solid #E9EEF2;
        td{
          padding: 16px;
          height:68px;
			    background-color: #fff;
          word-break: break-all;
        }
      }
    }
    .name {
      padding: 0;
      display: inline-block;
      display: flex;
      align-items: center;
      .role-lable {
        display: inline-block;
        white-space: nowrap;
        padding: 4px 8px;
        border-radius: 2px;
        font-size: 12px;
        line-height: 12px;
        margin-left: 8px;
      }
      .is-finance {
        background: rgba(255, 128, 51, .08);
        color: #FF8033;
      }
      .is-operator {
        background: rgba(247, 181, 0, .08);
        color: #F7B500;
      }
      .is-admin {
        background: rgba(58, 165, 255, .08);
        color: #599FFF;
      } 
    }
    .text-center{
      text-align: center;
    }
    .color-red{
      color: #F4455C;
    }
    .btn{
      display: inline-block;
      color: #599FFF;
      font-size: 14px;
      cursor: pointer;
      &+.btn{
        margin-left: 20px;
      }
    }
  }

  .nodata-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    .nodata-img{
      width: 200px;
      height: 120px;
    }
    .nodata-text{
      color: #91999F;
      font-size: 16px;
      line-height: 24px;
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/Staff.vue